var _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEquipment = function SvgEquipment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 19.657a4 4 0 0 1 1.172-2.829l1.974-1.974a.5.5 0 0 1 .854.353v14.586a.5.5 0 0 1-.854.353l-1.974-1.974A4 4 0 0 1 18 25.343zm-4 5.686a4 4 0 0 1-1.172 2.829l-1.974 1.974a.5.5 0 0 1-.854-.353V15.207a.5.5 0 0 1 .854-.353l1.974 1.974A4 4 0 0 1 14 19.657z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 19,
    x: 24,
    y: 13,
    fill: "currentColor",
    rx: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 19,
    y: 13,
    fill: "currentColor",
    rx: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 4,
    d: "M28 14c0-6.627-5.373-12-12-12S4 7.373 4 14",
    opacity: 0.4
  })));
};
export default SvgEquipment;